<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title" v-t="'message.item_edit_buddycom_call_setting'"></div>

                <hr class="dialog-hr"/>
                <div class="dialog-body">
                    <el-form>
                        <table width="100%">

                            <!-- GIFカテゴリー -->
                            <tr class="setting-name-1">
                                <td class="object-item">
                                    <span v-t="'message.item_buddycom_call_gif_category'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div
                                            slot="content"
                                            style="text-align:left"
                                            v-html="$t('message.item_hint_buddycom_call_gif_category')"
                                        ></div>
                                        <img
                                            class="icon-help"
                                            :src="require('@/assets/icon_help.svg')"
                                            alt=""/>
                                    </el-tooltip>

                                    <div class="setting-input-below">
                                        <el-select
                                            class="select-option-item"
                                            v-model="inputItems.gifCategoryType.value"
                                            @change="setButtonStatus()"
                                            :popper-append-to-body="false"
                                        >
                                            <el-option
                                                v-for="gifCategory in gifCategoryList"
                                                :key="gifCategory.value"
                                                :label="gifCategory.label"
                                                :value="gifCategory.value"
                                            />
                                        </el-select>
                                    </div>
                                </td>
                            </tr>

                            <!-- カメラOFF時の画像 -->
                            <tr class="setting-name-1">
                                <td class="object-item">
                                    <span v-t="'message.item_buddycom_call_camera_off_image'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div
                                            slot="content"
                                            style="text-align:left"
                                            v-html="$t('message.item_hint_buddycom_call_camera_off_image')"
                                        ></div>
                                        <img
                                            class="icon-help"
                                            :src="require('@/assets/icon_help.svg')"
                                            alt=""/>
                                    </el-tooltip>

                                    <div
                                        class="drop-zone"
                                        :class="{ 'is-dragging': isDragging }"
                                        @dragenter.prevent="onDragEnter"
                                        @dragover.prevent="onDragOver"
                                        @dragleave.prevent="onDragLeave"
                                        @drop.prevent="handleDrop"
                                        @dragstart.prevent
                                    >
                                        <p>
                                            <span v-if="!isDragging" v-t="'message.drop_zone_default_text'"></span>
                                            <span v-else v-t="'message.drop_zone_dragging_text'"></span>
                                        </p>

                                        <input
                                            ref="fileInput"
                                            type="file"
                                            accept="image/png, image/jpeg"
                                            @change="handleFileSelect"
                                            style="display:none"
                                        />
                                        <el-button
                                            size="small"
                                            class="zone-button"
                                            @click.stop="$refs.fileInput.click()"
                                            v-t="'message.drop_zone_select_file_button'"
                                        ></el-button>

                                        <div v-if="previewUrl" class="preview-wrapper">
                                            <img
                                                :src="previewUrl"
                                                alt="preview"
                                                class="preview"
                                                draggable="false"
                                                @mousedown.prevent
                                                @dragstart.prevent
                                                @contextmenu.prevent
                                            />
                                        </div>
                                    </div>
                                    <el-button
                                        class="reset-button"
                                        size="small"
                                        type="danger"
                                        @click.stop="handleResetImage"
                                        v-t="'message.button_restore_to_default'"
                                    ></el-button>
                                </td>
                            </tr>
                        </table>
                    </el-form>
                </div>

                <hr class="dialog-hr"/>
                <!-- 操作ボタン（キャンセル／保存） -->
                <div class="dialog-button-field">
                    <el-button
                        class="dialog-cancel-button"
                        v-t="'message.button_cancel'"
                        @click="$emit('cancel')"
                    ></el-button>
                    <el-button
                        class="dialog-ok-button"
                        :disabled="!isSaveButtonEnabled"
                        v-t="'message.button_save'"
                        @click="saveChange()"
                    ></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

import commonValidate from '../../../common-validate.js';
import commonUtil from '@/components/commonutil.js';
import callCameraOff from '@/assets/call_camera_off.svg';

export default {
    props: {
        buddycomCallSettingInfo: {
            type: Object,
            required: true,
            default: () => ({gifCategoryTypeValue: '', imageUrl: ''})
        }
    },
    data() {
        return {
            gifCategoryList: [],     // GIFカテゴリ一覧
            previewUrl: '',          // 画像プレビュー用のURL
            namedFile: null,         // サーバ送信用のFile（ファイル名・拡張子を保証して保持）
            isDragging: false,       // ドラッグ状態
            dragCounter: 0,          // ← dragenter / dragleave の誤検出を防止
            inputItems: {            // フォーム検証用の入力オブジェクト（commonValidateと連携）
                gifCategoryType: {value: '', valid: true},
                imageData: {value: null, valid: true}
            },
            maxFileSizeBytes: 10 * 1024 * 1024 // 10MB
        };
    },
    computed: {
        isModified() {
            const gifChanged =
                this.buddycomCallSettingInfo.gifCategoryTypeValue !== this.inputItems.gifCategoryType.value;
            const imgChanged =
                this.buddycomCallSettingInfo.imageUrl !== this.previewUrl;
            return gifChanged || imgChanged;
        },
        isValidForm() {
            return commonValidate.checkFormValidation(this.inputItems);
        },
        isSaveButtonEnabled() {
            return this.isValidForm && this.isModified;
        }
    },
    created() {
        this.gifCategoryList = commonUtil.getGifCategoryTypeList(this.$i18n);
        const matchedItem = this.gifCategoryList.find(
            item => item.value === this.buddycomCallSettingInfo.gifCategoryTypeValue
        );
        if (matchedItem) {
            this.inputItems.gifCategoryType.value = matchedItem.value;
        }
        this.previewUrl = this.buddycomCallSettingInfo.imageUrl;
    },
    methods: {
        // --- ドラッグ判定 ---
        onDragEnter() {
            this.dragCounter++;
            this.isDragging = true;
        },
        onDragLeave() {
            this.dragCounter--;
            if (this.dragCounter <= 0) this.isDragging = false;
        },
        onDragOver() {
            this.isDragging = true;
        },

        // --- ファイル処理 ---
        handleDrop(e) {
            this.isDragging = false;
            this.dragCounter = 0;
            const file = e.dataTransfer.files?.[0];

            // ファイル確認
            if (!file || !this.isSupportedImage(file)) {
                commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"alert_invalid_image_type"));
                e.target.value = ''
                return
            }

            // サイズ確認
            if (this.isTooLarge(file)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_call_upload_file_too_big_custom").replace("{maxSize}", "10MB"));
                e.target.value = ''
                return;
            }

            this.setFile(file);
        },

        handleFileSelect(e) {
            const file = e.target.files?.[0];

            // ファイル確認
            if (!file || !this.isSupportedImage(file)) {
                commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"alert_invalid_image_type"));
                e.target.value = '';
                return;
            }

            // サイズ確認
            if (this.isTooLarge(file)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_call_upload_file_too_big_custom").replace("{maxSize}", "10MB"));
                e.target.value = ''
                return;
            }

            this.setFile(file);
            e.target.value = '';
        },

        // --- ファイル名・検証 ---
        mimeToExt(mime) {
            switch ((mime || '').toLowerCase()) {
                case 'image/png':
                    return 'png';
                case 'image/jpeg':
                    return 'jpg';
                default:
                    return 'bin';
            }
        },
        extToMime(ext) {
            switch ((ext || '').toLowerCase()) {
                case 'png':
                    return 'image/png';
                case 'jpg':
                case 'jpeg':
                    return 'image/jpeg';
                default:
                    return 'application/octet-stream';
            }
        },
        ensureNamedFile(blobOrFile) {
            if (!blobOrFile) return null;
            if (!(blobOrFile instanceof Blob)) return null;
            if (blobOrFile instanceof File && blobOrFile.name && /\.[A-Za-z0-9]+$/.test(blobOrFile.name)) {
                return blobOrFile;
            }
            const mime = blobOrFile.type || '';
            const ext = this.mimeToExt(mime);
            const name = `overlay_${Date.now()}.${ext}`;
            const type = mime || this.extToMime(ext);
            return new File([blobOrFile], name, {type});
        },
        // アップロード可能な画像かどうかを判定（JPEG, PNG のみ許可）
        isSupportedImage(f) {
            const allowed = ['image/jpeg', 'image/png'];
            if (f && allowed.includes(f.type)) return true;
            const ext = (f.name || '').split('.').pop()?.toLowerCase();
            return ['jpg', 'jpeg', 'png'].includes(ext);
        },

        // サイズチェック（true = 大きすぎる）
        isTooLarge(f) {
            return f && f.size > this.maxFileSizeBytes;
        },

        // --- UI状態管理 ---
        setFile(file) {
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl);
                this.previewUrl = null;
            }

            this.namedFile = this.ensureNamedFile?.(file) ?? file;
            const newUrl = URL.createObjectURL(file);
            this.previewUrl = newUrl;

            this.inputItems.imageData.value = newUrl;

            this.setButtonStatus();
        },

        async saveChange() {
            if (this.inputItems.gifCategoryType.value === '') {
                this.inputItems.gifCategoryType.value = 0;
            }

            let imageData = this.inputItems.imageData.value;

            if (this.namedFile) {
                imageData = await new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onload = e => resolve(e.target.result);
                    reader.readAsDataURL(this.namedFile);
                });
            }

            const req = {
                gifCategory: this.inputItems.gifCategoryType.value,
                previewUrl: this.previewUrl,
                imageData
            };

            this.$emit('save', req, this.namedFile);
        },
        handleResetImage() {
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl);
                this.previewUrl = null;
            }
            this.previewUrl = callCameraOff;
            this.inputItems.imageData.value = 'DEFAULT';
            this.namedFile = null;
            if (this.$refs.fileInput) this.$refs.fileInput.value = '';
            this.setButtonStatus();
        }
    },
    beforeDestroy() {
        if (this.previewUrl) {
            URL.revokeObjectURL(this.previewUrl);
            this.previewUrl = null;
        }
    }
};
</script>

<style scoped>
/*
  スタイル定義：
  - ドロップゾーンの見た目（ドラッグ中の強調、アニメーション）
  - プレビュー画像の表示制御（サイズ、ドラッグ・選択禁止）
  - リセットボタンなど各種ボタンの微調整
*/

.dialog-modal-mask {
    position: fixed;
    inset: 0; /* top, right, bottom, leftを一括指定 */
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center; /* 垂直方向中央 */
    justify-content: center; /* 水平方向中央 */
}

.large-panel {
    /* コンテナ内で中央配置（.dialog-modal-mask が flex センター） */
    position: static; /* グローバルの absolute を打ち消す */
    left: auto;
    top: auto;
    margin-left: 0;
    margin-top: 0; /* ずれの原因を排除 */

    display: flex;
    flex-direction: column;
    justify-content: flex-start; /* 余白が間に入らないようにする */

    width: min(1000px, 90vw);
    height: auto;
    max-height: 85vh; /* 画面に収まるように上限 */

    background: #fff;
    border-radius: 8px;
    overflow: hidden; /* 外側スクロール禁止 */
}

.dialog-body {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    box-sizing: border-box;
}

.setting-input-below {
    margin-top: 10px;
}

/* 横長のドロップゾーン */
.drop-zone {
    display: block;
    border: 2px dashed #aaa;
    border-radius: 8px;
    padding: 24px 16px;
    text-align: center;
    cursor: pointer;
    width: 100%; /* テーブル内で横幅超過しない */
    margin: 10px 0 0 0; /* 横マージンを削除してはみ出し防止 */
    box-sizing: border-box;
    transition: background-color 0.3s, border-color 0.3s;
}

.drop-zone.is-dragging {
    background-color: #f5f5f5;
    border-color: #666;
    animation: dash 1.5s linear infinite;
}

/* 余白抑制：説明テキストの段落マージンをリセット */
.drop-zone p {
    margin: 0;
}

.preview {
    max-width: 100%;
    height: auto;
    max-height: 200px;
    object-fit: contain;

    /* ここから追加：選択・ドラッグ・コピー禁止 */
    user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -moz-user-select: none;
}

@keyframes dash {
    to {
        border-dash-offset: 20;
    }
}

.zone-button {
    margin-top: 8px;
}

.preview-wrapper {
    margin-top: 15px;
}

.preview {
    max-width: 100%;
    height: auto;
    max-height: 200px;
    object-fit: contain;
}

.reset-button {
    color: #f56c6c !important;
    background-color: white !important;
    border-color: #f56c6c !important;
    min-width: 80px;
    padding: 4px 12px;
    font-size: 13px;
    line-height: 1;
    margin-top: 10px;
}

/* ヘッダーの縦位置調整（タイトルを上端とHRの中央に配置） */
.large-panel > .dialog-title {
    height: 60px; /* ヘッダー高さを固定 */
    display: flex; /* 垂直中央揃えにするためflex化 */
    align-items: center; /* 縦方向センター */
    padding: 0 20px; /* 左右パディングのみ */
    box-sizing: border-box;
}

.large-panel > hr.dialog-hr {
    margin: 0; /* タイトル下の余白をなくす（Appの微小マージンを打ち消し） */
}

</style>
